
import React from 'react'
import { useRoomPeer } from 'hooks/use-room-peer';
import { useParams } from 'react-router-dom'
import { Audio } from 'components/atoms/audio';
import { Video } from 'components/atoms/video';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginLeft: 0,
    marginRight: 0,
    width: 'auto',
  },
}));


export const Room = () => {
  const { id } = useParams<{id: string}>();
  const { localStream, users } = useRoomPeer(id);
  const classes = useStyles();

  return (
    <Grid container spacing={5} className={classes.container}>
      <Grid item lg={2} md={6} xl={3} xs={12}>
        <Card>
          <CardHeader title={'you'} />
          <CardContent>
            <Video stream={localStream}></Video>
          </CardContent>
        </Card >
      </Grid>

      {users.map((user) => (
        <Grid item lg={2} md={6} xl={3} xs={12}>
          <Card>
            <CardHeader title={user.peerId} />
            <CardContent>
              <Video stream={user}></Video>
            </CardContent>
            <Audio stream={user}></Audio>
          </Card>
        </Grid>
      ))}

    </Grid>
  )
}
